import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CATALOG_CONFIGURABLE_BUNDLE_ROUTE_PATH, CATALOG_PRODUCT_ROUTE_PATH, CATALOG_SEARCH_ROUTE_PATH } from '@libs/shared/models';
import { ConfigurableBundlesComponent } from '../configurable-bundles';
import { ProductDetailComponent } from '../product-detail/product-detail.component';
import { CatalogSearchRouteComponent } from './catalog-search-route';

export const catalogSearchRoutes: Routes = [
  {
    path: CATALOG_SEARCH_ROUTE_PATH,
    component: CatalogSearchRouteComponent,
  },
  {
    path: CATALOG_PRODUCT_ROUTE_PATH,
    component: ProductDetailComponent,
  },
  {
    path: CATALOG_CONFIGURABLE_BUNDLE_ROUTE_PATH,
    component: ConfigurableBundlesComponent,
  },
];

@NgModule({
  imports: [
    OverlayModule,
    RouterModule.forChild(catalogSearchRoutes),
    CatalogSearchRouteComponent,
  ],
  exports: [
    CatalogSearchRouteComponent,
  ],
})
export class CatalogSearchModule {
}
